import { useCallback, useEffect } from 'react';
import { constants } from 'lib_ui-services';
import useEventSink from './useEventSink';

/*
    When a new ReadProvider is active (which occurs when its child field becomes focused), reset the RFID service reads.
    This prevents tags that were scanned for a previous ReadProvider from being excluded for the newly active ReadProvider.
    For example if you're taking inventory and scan a location tag but accidentally pick up an asset tag as well,
    this hook allows the asset tag to be re-scanned when scanning assets instead of excluding it.
 */
const _p = { useEventSink };
export const _private = _p;
export default function useResetReadsIfActivated(active) {
    const [, publish] = _p.useEventSink();

    const resetReads = useCallback(() => {
        publish(
            { sensorType: constants.sensorTypes.RFID },
            { verb: 'reset', namespace: 'sensor', relation: 'read' } // this will reset the RFID service's reads
        );
    }, [publish]);

    useEffect(() => {
        if (active) {
            // only one ReadProvider will be active, so only resetting if active prevents unnecessary resets
            resetReads();
        }
    }, [active, resetReads]);
}
